"use client";

import Tabs from "@/components/Tabs";
import { useParams, usePathname } from "next/navigation";

export default function DashboardHeader() {
  const pathname = usePathname();
  const params = useParams<{ id: string }>();

  if (
    (pathname.includes("/dashboard/robots") && params.id) ||
    pathname.includes("/dashboard/robots/create")
  ) {
    return null;
  }

  return (
    <div className="w-full max-w-5xl">
      <Tabs
        items={[
          {
            href: "/dashboard/robots",
            label: "Robots",
          },
          {
            href: "/dashboard/subscription",
            label: "Subscriptions",
          },
          {
            href: "/dashboard/api",
            label: "API",
          },
        ]}
      />
    </div>
  );
}
